module.exports = {
  dateFormat: 'dd/mm/yyyy',
  loading: 'Charger',
  or: 'ou',
  navigation: {
    'advisory-tool': 'Page d\'accueil',
    systems: 'Systèmes',
  },
  vat: {
    excluded: 'htva',
    included: 'tva incl.',
  },
  validation: {
    maxCharacters: '{amount} caractères maximum',
  },
};



// WEBPACK FOOTER //
// ./js/lang/fr/general.js